{
  "confirmationNumber": "Numéro de confirmation {number}",
  "dateTimeRange": "{date} de {startTime} à {endTime}"
}
